export const RTL_LANGUAGES = ['ar', 'ur'];
export const SCRIPT_ID = 'usercentrics-cmp';
export const ROOT_ID = 'usercentrics-root';

export enum DATA_ATTRIBUTES {
  AMP_ENABLED = 'ampEnabled',
  AVOID_PREFETCH_SERVICES = 'avoidPrefetchServices',
  BLOCK_DATA_LAYER_PUSH = 'blockDataLayerPush',
  CONTROLLER_ID = 'controllerId',
  CLIENT_CONFIG = 'clientConfig',
  EU_MODE = 'euMode',
  ID = 'id',
  LANGUAGE = 'language',
  SETTINGS_CACHE = 'settingsCache',
  SETTINGS_ID = 'settingsId',
  SUPPRESS_CMP_DISPLAY = 'suppressCmpDisplay',
  TCF_ENABLED = 'tcfEnabled',
  VERSION = 'version',
}

// All global/window properties added by this UI should be added under the UC_UI namespace.
export const UC_UI_GLOBAL_NAMESPACE = 'UC_UI';
